"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LockClosed = function LockClosed(props) {
  return _react.default.createElement("svg", {
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, _react.default.createElement("title", null, props.altText), _react.default.createElement("path", {
    d: "M17.1852 10.4628C17.1866 10.4476 17.1876 10.4323 17.1876 10.4167C17.1871 10.2782 17.1318 10.1454 17.0338 10.0474C16.9358 9.94936 16.803 9.89409 16.6644 9.8936C16.6489 9.8936 16.6336 9.89458 16.6184 9.89592H16.1459V9.37508C16.1459 8.40815 15.7618 7.48081 15.078 6.79709C14.3943 6.11336 13.467 5.72925 12.5001 5.72925C11.5331 5.72925 10.6058 6.11336 9.92206 6.79709C9.23833 7.48081 8.85422 8.40815 8.85422 9.37508V9.89592H8.37708C8.36189 9.89458 8.34661 9.8936 8.33107 9.8936C8.19247 9.89409 8.05968 9.94936 7.96168 10.0474C7.86367 10.1454 7.80839 10.2781 7.80789 10.4167C7.80789 10.4323 7.80891 10.4476 7.81024 10.4628V18.7041C7.80891 18.7193 7.80789 18.7345 7.80789 18.7501C7.80839 18.8887 7.86367 19.0215 7.96168 19.1195C8.05968 19.2175 8.19247 19.2727 8.33107 19.2732C8.34661 19.2732 8.36189 19.2722 8.37708 19.2709H16.6184C16.6336 19.2722 16.6489 19.2732 16.6644 19.2732C16.803 19.2727 16.9358 19.2175 17.0338 19.1195C17.1318 19.0215 17.1871 18.8887 17.1876 18.7501C17.1876 18.7345 17.1866 18.7193 17.1852 18.7041V10.4628ZM8.8519 10.9376H16.1436V18.2292H8.8519V10.9376ZM9.89588 9.37508C9.89588 8.68441 10.1703 8.02203 10.6586 7.53366C11.147 7.04528 11.8094 6.77091 12.5001 6.77091C13.1907 6.77091 13.8531 7.04528 14.3415 7.53366C14.8299 8.02203 15.1042 8.68441 15.1042 9.37508V9.89592H9.89588V9.37508Z",
    fill: props.foregroundColor
  }), _react.default.createElement("path", {
    d: "M12.5 13.021C12.3619 13.021 12.2294 13.0759 12.1317 13.1735C12.0341 13.2712 11.9792 13.4037 11.9792 13.5418V15.6252C11.9792 15.7633 12.0341 15.8958 12.1317 15.9934C12.2294 16.0911 12.3619 16.146 12.5 16.146C12.6382 16.146 12.7706 16.0911 12.8683 15.9934C12.966 15.8958 13.0209 15.7633 13.0209 15.6252V13.5418C13.0209 13.4037 12.966 13.2712 12.8683 13.1735C12.7706 13.0759 12.6382 13.021 12.5 13.021Z",
    fill: props.foregroundColor
  }));
};

LockClosed.defaultProps = {
  altText: "LockClosed",
  foregroundColor: "#2D5AB4"
};
LockClosed.propTypes = {
  altText: _propTypes.default.string,
  foregroundColor: _propTypes.default.string
};
var _default = LockClosed;
exports.default = _default;